import ReactCountryFlag from "react-country-flag";

import { cn } from "@/utils/cn";
import { currencyToCountryCode } from "@/utils/currencyFlag";

interface CurrencyFlagProps {
  /** ISO-4217 currency code, e.g. "AED". May be null/undefined for rows with no currency. */
  code?: string | null;
  /** Render the currency code text next to the flag. Default true. */
  showCode?: boolean;
  className?: string;
  flagClassName?: string;
}

export const CurrencyFlag = ({
  code,
  showCode = true,
  className,
  flagClassName,
}: CurrencyFlagProps) => {
  // Guard: callers may pass null/undefined when a row has no currency set.
  if (!code) return null;

  const countryCode = currencyToCountryCode(code);

  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      {countryCode ? (
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          className={cn("rounded-[2px] shrink-0", flagClassName)}
          style={{ width: "1.25em", height: "0.95em" }}
          aria-label={code}
        />
      ) : (
        <span className="inline-flex size-3.5 shrink-0 items-center justify-center rounded-[2px] bg-muted text-[8px] font-bold text-muted-foreground">
          {code.slice(0, 1)}
        </span>
      )}
      {showCode && <span className="font-medium">{code}</span>}
    </span>
  );
};
